import { uiSurface } from "shared/ui/uiSurface"
import { Close } from "@mui/icons-material"
import { Box, IconButton, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { FC } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  onClose: () => void
}

export const OrderCreateDialogHeader: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Box
      {...uiSurface("UI-DLV2-034")}
      data-testid="order-create-header"
      sx={{
        px: 3,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
        color: "#fff",
      }}
    >
      <Typography variant="h6" fontWeight={600} color="inherit">
        {t("orderCreate.title")}
      </Typography>
      <IconButton
        data-testid="order-create-close-btn"
        size="small"
        onClick={onClose}
        sx={{ color: "#fff" }}
      >
        <Close />
      </IconButton>
    </Box>
  )
}
